import React, { useId } from "react";
import "./TextField.css";

const TextField = React.forwardRef(function TextField(
    {
        label,
        value,
        onChange,
        type = "text",
        placeholder,
        hint,
        error,
        required,
        maxLength,
        disabled,
        autoComplete = "off",
        ...rest
    },
    ref
) {
    const id = useId();
    const handle = (e) => onChange?.(e.target.value);
    const describedBy = error ? `${id}-err` : hint ? `${id}-hint` : undefined;

    return (
        <div className={`tfield ${error ? "tfield--invalid" : ""}`}>
            <label className="tfield__label uppercase-label" htmlFor={id}>
                {label}
                {required && <span className="tfield__req" aria-hidden="true">*</span>}
            </label>
            <input
                ref={ref}
                id={id}
                type={type}
                value={value ?? ""}
                onChange={handle}
                placeholder={placeholder}
                disabled={disabled}
                maxLength={maxLength}
                autoComplete={autoComplete}
                aria-invalid={error ? "true" : undefined}
                aria-describedby={describedBy}
                className="tfield__input focus-ring"
                {...rest}
            />
            {error ? (
                <span className="tfield__error" id={`${id}-err`} role="alert">
                    {error}
                </span>
            ) : hint ? (
                <span className="tfield__hint" id={`${id}-hint`}>
                    {hint}
                </span>
            ) : null}
        </div>
    );
});

export default TextField;
